import { render, staticRenderFns } from "./AccountNavigation.vue?vue&type=template&id=5fcf3449&scoped=true&"
import script from "./AccountNavigation.vue?vue&type=script&lang=ts&"
export * from "./AccountNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AccountNavigation.vue?vue&type=style&index=0&id=5fcf3449&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcf3449",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VLayout})
